import { Button, CircularProgress } from '@mui/material';
import { ReactElement, useState } from 'react';
import { Confirm, useNotify } from 'react-admin';

export interface ConfirmedActionButtonProps {
  label: string;
  icon: ReactElement;
  confirmTitle: string;
  confirmContent: string;
  onConfirm: () => Promise<void>;
  color?: 'primary' | 'secondary' | 'error' | 'warning' | 'success' | 'info' | 'inherit';
  size?: 'small' | 'medium' | 'large';
}

const ConfirmedActionButton: React.FC<ConfirmedActionButtonProps> = ({ label, icon, confirmTitle, confirmContent, onConfirm, color = 'primary', size = 'small' }) => {
  const notify = useNotify();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setConfirmOpen(false);
    setLoading(true);
    try {
      await onConfirm();
    } catch {
      notify(`Failed to ${label.toLowerCase()}`, { type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        startIcon={loading ? <CircularProgress size={14} color="inherit" /> : icon}
        onClick={(e) => {
          e.stopPropagation();
          setConfirmOpen(true);
        }}
        size={size}
        color={color}
        disabled={loading}
        variant="text"
      >
        {label}
      </Button>
      <Confirm isOpen={confirmOpen} title={confirmTitle} content={confirmContent} onConfirm={handleConfirm} onClose={() => setConfirmOpen(false)} />
    </>
  );
};

export default ConfirmedActionButton;
